// extracted by mini-css-extract-plugin
module.exports = {"segment":"Segment--segment--1NwuN","placeholderAnim":"Segment--placeholderAnim--31Gn-"};